import { render, staticRenderFns } from "./setTimeCog.vue?vue&type=template&id=2dc86496&scoped=true&"
import script from "./setTimeCog.vue?vue&type=script&lang=js&"
export * from "./setTimeCog.vue?vue&type=script&lang=js&"
import style0 from "./setTimeCog.vue?vue&type=style&index=0&id=2dc86496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc86496",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCardText,VCheckbox,VCol,VRow,VSubheader})
